/* eslint-disable */
module.exports = {
  bind: {
    bindwb: '綁定微博',
    binddb: '綁定豆瓣',
    bindqq: '綁定qq',
    hasbind: '已綁定',
    yjbdwx: '一键綁定微信',
    bindway: '綁定以下一種登錄方式',
  },
  "global": {
    "timeout": "請求超時",
    "content-loading": "內容加載中",
    "to-home": "返回首頁",
    "setting": "設定",
    "quit": "按 Esc 退出",
    "note-loading": "文章加載中",
    "forbidden-desc": "很抱歉，網頁版寫文章功能暫不支持手機/平板電腦，你可以在簡書App中使用",
    "cancel": "取消",
    "commit": "提交",
    "download": "下載簡書App"
  },
  "not-found": {
    "title": "您要找的頁面不見了",
    "desc": "因為您的連結位址有誤，連結位址為",
    "to-home": "返回「簡書」首頁"
  },
  "note-action": {
    'time-publish': '定時發佈',
    "publicize": "直接發佈",
    "publicize-paid-note": "發佈為付費文章",
    "publicized": "已發佈",
    "compile-paid-note": "發佈更新和設定",
    'set-publicize-style': '設置發布樣式',
    'topping-note': '置頂文章',
    'untopping-note': '取消置頂文章',
    'topping-success': '置頂文章成功',
    'untopping-success': '取消置頂文章成功',
    "move-note": "移動文章",
    "private-note": "設為私密",
    "open-in-new-window": "在新窗口打開",
    "to-history": "歷史版本",
    "share": "分享文章",
    "del-note": "删除文章",
    'set-unreprintable': '設置禁止轉載',
    'cancel-unreprintable': '取消禁止轉載',
  },
  "settings": {
    "change-locale": "顯示語言已切換成功",
    "change-read-mode": "閱讀模式已切換成功",
    "change-font": "顯示字體已切換成功",
    "change-to-simple": "切換至簡體",
    "change-to-traditional": "切換至繁體",
    "open-night-mode": "打開夜間模式",
    "change-to-song": "切換至宋體",
    "close-night-mode": "關閉夜間模式",
    "change-editor": "默認編輯器已切換成功",
    "editor": "默認編輯器",
    "rich-editor": "富文字編輯器",
    "feedback": "幫助與迴響",
    "md-editor": "MarkDown編輯器",
    "recycle": "回收站",
    "need-help": "遇到問題",
    "common-issue": "常見問題",
    "change-to-black": "切換至黑體",
    "display": "設定顯示模式",
    'on': '開',
    'off': '關',
    'sync-scroll': '同步滾動',
    'switch-sync-scroll': '同步滾動狀態切換成功',
    'author-verfy':'簡書作者實名認證',
  },
  grammar: {
    'grammar': 'Markdown語法參考',
    'h1': '# 一級標題',
    'h2': '## 二級標題',
    'h5': '##### 五級標題',
    'ul1': '- 列表第一項',
    'ul2': '- 列表第二項',
    'ol1': '1. 有序列表第一項',
    'ol2': '2. 有序列表第二項',
    'link': '[標題](鏈接地址)',
    'image': '![圖片描述](圖片鏈接地址)',
    'italic': '*斜體*',
    'bold': '**粗體**',
    'code-block': '> 引用段落',
    'blockquote': '```\n代碼塊\n```',
  },
  "notebooks": {
    "new-notebook-ing": "新建文集中…",
    "del-notebook-tip": "確認删除文集《{name}》，文章將被移動到回收站。",
    "new-notebook-empty": "文集名不能為空",
    "new-notebook": "新建文集",
    "rename-notebook-tip": "請輸入新文集名",
    "to-homepage": "回首頁"
  },
  "notes": {
    'audio': '音頻',
    "new-note-ing": "新建文章中…",
    "new-note": "新建文章",
    "new-note-bottom": "在下方新建文章",
    "save-word": "{wordNum}字",
    "default-note-title": "無標題文章",
    "word-num": "字數：",
    "move-note-success": "文章已移動至新文集",
    "del-note-confirm-tip": "確認删除文章《{title}》，文章將被移動到回收站，您可以在那裡恢復它。60天后將被徹底删除。",
    "topping": '置頂',
  },
  "pay-note": {
    "step-title": "付費文章設置",
    "agree-title": "付費文章協定",
    "step-two": "輸入定價",
    "cancelbtn": "不同意",
    "okbtn": "同意",
    "step-one": "設定試讀範圍",
    "step-one-des": "請你在右側選擇免費可讀的部分",
    "i-agree": "我同意",
    "confirming-btn": "發佈中…",
    "cancel-btn": "取消",
    "wrong-price": "請輸入正確的金額({minnum}-{maxnum}元)",
    "confirm-btn": "確認並發佈",
    "yuan": "元",
    'step-three': '設置音頻',
    'pay-for-audio': '購買文章後才能播放',
    'free-for-audio': '免費播放',
    "price-tip": "您可自由設置文章定價，最低1元，最高2000元。",
    'mask-item-des': '該分割線以上免費可讀',
    'publish-paid-notes': '發表付費文章',
    'publish-explain-1': '付費文章即讀者付費後才可解鎖閱讀的文章，擁有付費文章發表權限的作者可以發表付費文章。',
    'publish-explain-2': '該功能僅針對「簡書會員」或「簡書鑽大於 {minJSD}」或「被邀請」的用戶開放，您可以通過購買簡書會員快速獲得該資格。',
    'about-jsd': '了解簡書鑽特權',
    'open-js-member': '開通簡書會員',
  },
  'publish-setting': {
    'set-cover-img': '設置封面圖，優化文章的顯示效果',
    'set-note': '未設置則自動按默認樣式顯示',
    'choose-img-count': '選擇圖片數量',
    'one-img': '一圖',
    'three-img': '三圖（無摘要）',
    'upload-cover-img': '上傳封面圖',
    'click-to-upload': '點擊上傳',
    'upload-note1': '尺寸大于 360×360，格式 png/jpg',
    'upload-note2': '單張圖片大于 440×320，格式 png/jpg',
    'change': '更換',
    'input-abstract': '輸入摘要',
    'input-placeholder': '選填，30字內，如不填寫會默認抓取首段內容',
    'confirm-btn': '保存',
    'confirming-btn': '保存中...',
    'cancel-btn': '取消',
    'preview': '效果預覽',
    'preview-note': '僅供參考，具體效果會根據不同手機型號而變化',
    'save': '保存',
    'saving': '保存中...',
    'confirmed': '發布樣式已更新',
    'notes-over-limit': '摘要字數超出限制！',
  },
  "share": {
    "to-douban": "豆瓣",
    "to-wechat": "微信",
    "more": "更多分享",
    "to-weibo": "微博",
    "copy-link": "複製連結",
    "wechat-des": "打開微信“掃一掃”，打開網頁後點擊荧幕右上角分享按鈕",
    "trailing-jianshushe": "-簡書社",
    "to-googleplus": "Google+",
    "to-qzone": "QQ空間",
    "to-twitter": "Twitter",
    "to-facebook": "Facebook"
  },
  "error": {
    "try-again": "操作失敗，請再試一次",
    "save-again": "有內容未保存成功，確定要離開？",
    "text-no-empty": "文字不能為空",
    "link-no-empty": "連結不能為空",
    "file-size-over": "文件大小超過{size}M",
    "file-type-error": "圖片格式錯誤，請使用jpg/jpeg/png/gif檔案",
    "video-max-over": "視頻不能超過{num}個",
    "content-no-empty": "內容不能為空",
    "uploading-img": "正在上傳圖片，請稍等…",
    "file-not-exit": "檔案不存在",
    "fail-refresh": "操作失敗，可以刷新頁面嘗試",
    "need-bind-phone": "需要綁定手機號後才能發佈文章喲~",
    "upload-fail": "有圖片未上傳成功，請删除或重新上傳圖片。如需幫助，請",
    "save-again-soft": "上一篇文章有內容未保存成功，需要手動保存",
    "content-not-enough": "內容少於{num}段，不能發表為付費文章",
    "click": "點擊",
    'no-nb': '文集不存在',
    "data-empty": "暫無數據"
  },
  "tooltip": {
    "bold": "粗體",
    "link": "插入連結",
    "h3": "標題3",
    "video": "插入視頻",
    "audio": "插入音頻",
    'math-formula': '數學公式',
    "audioExist": "已有音頻",
    "h4": "標題4",
    "undo": "撤銷",
    "h1": "標題1",
    "redo": "重做",
    "expand": "全屏",
    "save": "保存",
    "to-normal-mode": "返回",
    "preview": "切換到預覽模式",
    "compress": "退出全屏",
    "quote": "引用",
    "italic": "斜體",
    "strikethrough": "删除線",
    "hr": "分割線",
    "h2": "標題2",
    "history": "歷史版本",
    "picture": "插入圖片",
    'grammar': 'Markdown語法參考',
  },
  "pubbtn": {
    "publish-update": "發佈更新",
    "publishing": "發佈中…",
    "compile-paid-note": "發佈更新和設定",
    "cancel-publish": "取消發佈",
    "publicize": "發佈文章",
    "publicize-paid-note": "發佈為付費文章",
    "save-fail": "保存失敗，請手動保存",
    "publicized": "已發佈",
    "saving": "保存中…",
    "saved": "已保存",
    'audio-transcoding': '音頻轉碼中，請稍後發布',
  },
  "modal": {
    "insertlink": "插入連結",
    "confirm": "確認",
    "wrong-video-source": "暫不支持此視頻地址",
    "cancel": "取消",
    "tc": "騰訊",
    "video-url-des": "請輸入視頻地址",
    "imglinkdes": "請輸入網絡圖片連結",
    "linktxtdes": "連結文字",
    "insertimgdes": "點擊上傳（可多張）",
    "chooseurlimg": "或選擇網絡圖片",
    "imgpolicy": "圖片私密性",
    "only-support": "現時只支持",
    "getting-linkinfo": "正在獲取連結標題…",
    "choosesysimg": "或上傳本地圖片",
    "video-loading": "正在加載視頻，請稍等…",
    "video": "視頻",
    "removeLink": "删除連結",
    "insertimg": "插入圖片",
    "urldes": "連結位址",
    "insertvideo": "插入視頻",
    "yk": "優酷",
    "getting-linkinfo-fail": "無法獲取連結標題，請手動輸入連結文字",
    "fetch-video-info-failed": "抱歉，您輸入的地址無法識別！",
    'insert-audio': '插入音頻',
    'upload-audio': '點擊上傳',
    'audio-support': '支持 {format} 格式，大小不超過 {size} M',
    'audio-cancle': '取消上傳',
    'audio-upload-unfinished': '音頻上傳尚未完成',
    'reupload-audio': '重新上傳',
    'retry': '重試',
    'audio-upload-failed': '上傳失敗',
    'audio-uploading-failed': '音頻未上傳成功',
    'audio-upload-complete': '上傳完成',
    'audio-upload-error': '網路異常，請稍後再試',
    'audio-name': '音頻名稱',
    'audio-author': '音頻作者',
    'insert-audio-name': '輸入音頻名稱',
    'insert-audio-author': '輸入音頻的創作者',
    'delete-audio': '刪除音頻',
    'audio-confirm': '確定',
    'audio-overlarge': '文件大小超過限制！',
    'audio-delete': '確認刪除音頻嗎？',
    'no-name': '佚名',
    'close-audio-warning': '確認關閉嗎？',
    'close-audio-warning2': '關閉後，當前的更改或上傳將丟失',
    'audio-transcoding': '音頻正在轉碼，請稍候',
    'audio-edit': '編輯',
    'insert-math-formula': '插入數學公式',
    'common-expression': '常用表達式',
    'common-function': '常用函數',
    'common-symbol': '常用符號',
    'greek-alphabet': '希臘字母',
    'special-symbol': '特殊符號',
    'math-formula-grammar': '數學公式語法',
    'insert-empty': '輸入內容為空，請重新輸入！',
    'insert-audio-modal': '插入音頻',
    'insert-audio-explain': '插入音頻功能，僅對簡書鑽大于 {minJSD} 或被邀請的用戶開放，你可以通過購買簡書會員，或者積極參與簡書社區互動（喜歡優質文章/喜歡自己的文章）等方式，增加你的簡書鑽',
  },
  "history": {
    "publicize": "公開發表文章",
    "recovery-to": "恢復到這個版本",
    "timeago": "剛剛_秒以前_分鐘以前_小時以前_天以前_周以前_月以前_年以前",
    "android": "簡書Android App",
    "ios-night": "簡書iPhone App黑夜版",
    "total-items": "共{num}條歷史版本",
    "ios": "簡書iPhone App",
    "update": "發佈更新",
    "web": "簡書網站",
    "auto-save": "自動保存",
    "recovery": "版本恢復",
    "filter": "篩選"
  },
  "trash": {
    "del-time2": "{time}天后清除",
    "recovery": "恢復文章",
    "delete": "徹底删除",
    "del-time": "將於{time}清除",
    "trash": "回收站（{num}）",
    "recovering": "恢復文章中…",
    "deleting": "徹底删除中…"
  },
  "verifymodal": {
    "resend-captcha": "重新發送驗證碼",
    "loading": "正在加載驗證資訊…",
    "send-captcha": "發送驗證碼",
    "by-phone": "用手機短信驗證",
    "send-captcha-error": "驗證碼發送失敗，可刷新頁面重試",
    "confirming": "確認中…",
    "confirm": "確認",
    "empty-captcha": "驗證碼為空",
    "sending-captcha": "{num}秒後重新發送",
    "email-prefix": "用郵箱",
    "captcha": "驗證碼",
    "title": "安全驗證",
    "by-email": "用郵箱驗證",
    "verify": "驗證",
    "verify-captcha-error": "驗證碼錯誤，請重試",
    "des": "為了保證你的帳號安全，請先驗證身份，驗證成功後進行下一步操作，驗證碼{minute}分鐘內有效",
    "sms-prefix": "用手機"
  },
  "app": {
    "name": "簡書"
  },
  "phoneModal": {
    "tip": "綁定遇到問題",
    "yjjb": "一鍵綁定",
    "cancel": "取消",
    "wxoccupy": "微信被佔用",
    "clickbind": "點擊綁定",
    "bindwx": "綁定微信",
    "bindwxtip": "請使用微信掃描二維碼進行綁定",
    "bindtitle": "綁定手機號和微信",
    "nobind": "未綁定",
    "bindtip": "發佈公開文章需要同時綁定手機號和微信",
    "href": "點擊查看幫助",
    "bindwxphone": "綁定手機號和微信",
    "phone-error": "輸入的手機號碼有誤，請重新輸入",
    "captcha-regex-error": "驗證碼格式不對，請重新輸入",
    "get-otp-info-error": "獲取國家區號失敗，請刷新頁面重試",
    "hot-countries": "熱門國家和地區",
    "captcha": "簡訊驗證碼",
    "phone-num": "手機號",
    "all": "全部",
    "title": "綁定手機"
  },
  "publishSuccessModal": {
    "lastest-collections": "最近投稿",
    "post-des": "向專題投稿，讓文章被更多人發現",
    "success-des": "發佈成功，點擊查看文章",
    "new-collection": "新建",
    "including-note": "收錄中",
    "copy-success": "已複製到剪貼板中",
    "posted-note": "等待稽核",
    "post-note": "投稿",
    "copy-fail": "此瀏覽器不支持，複製失敗，建議用Chrome",
    "my-collections": "我管理的專題",
    "include-note": "收錄",
    "included-note": "已收錄",
    "no-more-data": "沒有更多了",
    "posting-note": "投稿中",
    "get-more-data": "點擊加載更多",
    "search-collection": "搜索專題",
    "recomend-collections": "推薦專題"
  },
  "collections": {
    "suber-num": "{num}人關注",
    "note-num": "{num}篇文章"
  },
  'upload-img': {
    'upload-success': '上傳成功',
    'upload-fail': '上傳失敗',
    'upload-size-error': '上傳圖片尺寸錯誤',
    'upload-net-error': '網絡錯誤，請重試',
  },
  tips: {
    'set-reprintable-success': '設置轉載狀態成功',
    'set-reprintable-fail': '設置轉載狀態失敗',
  },
};



// WEBPACK FOOTER //
// ./src/constants/locales/zh-TW.js